<section class="container">
<div class="container py-lg-5 py-4 px-lg-4 px-3">
  <div [ngClass]="{ 'card shadow-lg p-lg-4 p-3': !isMobile && !isCard }">
    <h3 class="section-title mb-4">
      {{ data.details.title.split(' ')[0] }}
      <span>{{ data.details.title.split(' ')[1] }}</span>
    </h3>

    <p-galleria
      [value]="data.details.services"
      [(visible)]="displayCustom"
      [(activeIndex)]="activeIndex"
      [responsiveOptions]="responsiveOptions"
      [containerStyle]="{}"
      [numVisible]="7"
      [circular]="true"
      [fullScreen]="true"
      [showItemNavigators]="true"
      [showThumbnails]="false"
    >
      <ng-template pTemplate="item" let-item>
        <img [src]="item.image" class="galleria-image" />
      </ng-template>
    </p-galleria>

    <div *ngIf="data?.details?.services">
      <!-- Mobile: horizontal scroll -->
      <div class="scroll-wrapper d-flex d-md-none mt-4" *ngIf="!isSorted">
        <div class="scroll-item me-3" *ngFor="let item of data.details.services; let i = index">
          <img
            [src]="item.image"
            [alt]="item.name"
            class="gallery-img"
            (click)="imageClick(i)"
          />
        </div>
      </div>

      <!-- Mobile: horizontal scroll -->
      <div class="scroll-wrapper d-flex d-md-none mt-4" *ngIf="isSorted || isCard">
        <div class="scroll-item me-3" *ngFor="let item of data.details.services; let i = index">
          <img
            [src]="item.image"
            [alt]="item.name"
            class="gallery-img"
            (click)="imageClick(i)"
          />
        </div>
      </div>

      <!-- Desktop: grid layout -->
      <div class="row g-3 mt-4 d-none d-md-flex" *ngIf="isSorted && !isCard">
        <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of data.details.services; let i = index">
          <img
            [src]="item.image"
            [alt]="item.name"
            [ngClass]="{ 'full-image': isFullWidth, 'gallery-img': !isFullWidth }"
            (click)="imageClick(i)"
          />
        </div>
      </div>

      <!-- Desktop: horizontal carousel -->
      <div
        class="carousel-wrapper mt-4 d-none d-md-block"
        *ngIf="isCard"
        #carouselWrapper
      >
        <p-carousel
          [value]="data.details.services"
          [numVisible]="3"
          [numScroll]="1"
          [circular]="true"
          [autoplayInterval]="3000"
          [showIndicators]="true"
          [showNavigators]="false"
        >
          <ng-template pTemplate="item" let-item>
            <img
              [src]="item.image"
              [alt]="item.name"
              class="gallery-img img-wrapper"
              (click)="imageClick(activeIndex)"
            />
          </ng-template>
        </p-carousel>
      </div>


      <!-- Desktop: masonry layout -->
      <div class="masonry-grid mt-4 d-none d-md-block" *ngIf="!isSorted">
        <div class="masonry-item" *ngFor="let item of data.details.services; let i = index">
          <img
            [src]="item.image"
            [alt]="item.name"
            [ngClass]="{ 'full-image': isFullWidth, 'gallery-img': !isFullWidth }"
            (click)="imageClick(i)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
</section>